import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    try {
      await authAPI.forgotPassword({ email });
      setMessage('If an account with that email exists, a password reset link has been sent.');
      toast.success('Password reset email sent.');
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to send password reset email.');
      toast.error('Failed to send password reset email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2>Forgot Password</h2>
      <p className="text-center text-muted mb-3">Enter your email to reset your password.</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="email"
            className="form-control"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </div>
        <button type="submit" className="btn btn-primary w-full mt-2" disabled={loading}>
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
      {message && <p className="text-center mt-3">{message}</p>}
      <p className="text-center mt-3">
        <Link to="/login">Back to Login</Link>
      </p>
    </AuthLayout>
  );
};

export default ForgotPassword;
